// @flow

import React from "react";

export const VimcarBookingLogomarkNeutralInverse = (
  props: any
) => {
  return (
    <svg
      fill="#fff"
      height="180"
      id="vimcar-booking-logomark-neutral-inverse"
      viewBox="0 0 180 180"
      width="200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M173.167 11.006c0-.172 0-.37-.024-.543a12.1 12.1 0 0 0-1.728-4.688c-.148-.198-.271-.37-.419-.568-.296-.42-.568-.864-.963-1.234-.468-.518-1.011-.987-1.554-1.431-.025 0-.074-.074-.099-.099-1.407-1.012-2.961-1.777-4.639-2.147h-.025a9.4 9.4 0 0 0-2.221-.271c-.543 0-1.086.024-1.678.098-.198 0-.42 0-.617.025-1.456.197-2.863.716-4.146 1.431l-64.73 35.45a1.8 1.8 0 0 1-1.431 0L24.163 1.555C22.88.839 21.473.32 20.042.123c-.198 0-.42 0-.617-.024A12 12 0 0 0 17.747 0c-.74 0-1.456.148-2.221.271H15.5c-1.678.37-3.282 1.086-4.64 2.147l-.074.074c-.567.445-1.085.914-1.604 1.432-.345.37-.641.814-.962 1.234-.148.197-.296.345-.42.543-.839 1.406-1.456 3.01-1.678 4.688 0 .198 0 .37-.024.568A13 13 0 0 0 6 12.66c0 .715.148 1.406.271 2.122v.148c.198.963.543 1.876.988 2.715L77.96 171.51a11.83 11.83 0 0 0 3.405 5.182c.025.025.099.074.148.148.444.42.963.741 1.456 1.086.272.173.543.346.84.518.197.099.345.247.542.346.074.024.148.074.247.098.148.075.247.075.37.149.42.172.84.296 1.283.444.346.098.691.197 1.061.271.42.074.79.099 1.185.173.37.025.79.074 1.16.074s.74-.025 1.16-.074c.42-.025.79-.074 1.184-.173.346-.074.691-.173 1.061-.271.444-.148.84-.272 1.284-.444a1 1 0 0 0 .37-.149c.074-.024.148-.074.246-.098.198-.099.37-.247.543-.346.272-.172.568-.296.864-.518a16 16 0 0 0 1.456-1.086c.025-.024.099-.074.148-.148 1.555-1.431 2.764-3.208 3.406-5.182l70.628-153.842a11 11 0 0 0 .987-2.714v-.198c.148-.69.247-1.357.271-2.048 0-.567 0-1.135-.099-1.703M89.633 145.772 38.106 32.032l47.16 26.776c.838.444 4.614 2.172 8.908-.099l47.036-26.677z"
        fill="crrentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
